// extracted by mini-css-extract-plugin
export var wrapper = "benefits-item-module--wrapper--ZpxDe";
export var item = "benefits-item-module--item--ig2yw";
export var title = "benefits-item-module--title--IFeCt";
export var description = "benefits-item-module--description--62lyB";
export var decoration = "benefits-item-module--decoration--u7Oqk";
export var decoration1 = "benefits-item-module--decoration1--GXNIF";
export var decoration2 = "benefits-item-module--decoration2--9cIzp";
export var decoration3 = "benefits-item-module--decoration3--nJYbh";
export var decoration4 = "benefits-item-module--decoration4--W+Ugu";
export var decoration5 = "benefits-item-module--decoration5--eBjj4";
export var info = "benefits-item-module--info--sb8C3";
export var itemActive = "benefits-item-module--item-active--8K-+M";
export var left = "benefits-item-module--left--ZQhud";
export var right = "benefits-item-module--right--Aeog6";